import { Injectable, inject } from "@angular/core";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { switchMap, catchError, of } from "rxjs";
import { InventoryActions } from "./inventory.actions";

@Injectable()
export class InventoryEffects {
    private actions$ = inject(Actions);

    init$ = createEffect(() =>
        this.actions$.pipe(
            ofType(InventoryActions.initInventory),
            switchMap(() => of(InventoryActions.loadInventorySuccess({ inventory: [] }))),
            catchError((error) => {
                console.error("Error", error);
                return of(InventoryActions.loadInventoryFailure({ error }));
            })
        )
    );
}
